import withAemIntegration from "../../../withAemIntegration";
import serviceParser, { dealerDataMap } from "../../../utils/serviceParser";

import loadable from "../../../utils/loadable";
const Component = loadable(() =>
  import("@lexus.com/ui/dist/components/DealerLocation")
);

const DealerLocationEditConfig = {
  emptyLabel: "DealerLocation",
  isEmpty: function (props) {
    return !props || !props.title || props.title.trim().length < 1;
  },
};

const transformCtas = (ctas) => {
  return ctas.map((cta) => {
    return {
      ...cta,
      text: serviceParser(cta.text, dealerDataMap),
      href: serviceParser(cta.href, dealerDataMap),
      theme: cta.theme ? cta.theme : "SecondaryBlack",
    };
  });
};

const transformData = (props) => {
  return {
    heading: serviceParser(props.heading, dealerDataMap),
    headingColor: props.headingColor,
    dealerData: window.LEXUS.dealerData,
    ctas: transformCtas(props.ctas),
  };
};

const DealerLocation = (props) => {
  const data = transformData(props);

  return <Component {...data} />;
};

export default withAemIntegration(
  "lexus/components/dealer-details/dealer-location"
)(DealerLocation, DealerLocationEditConfig);
